import isEmpty from 'lodash/isEmpty'
import { htmlToPlainText } from '../html-to-plain-text'

// A derived-text check, not a string trim — an empty rich-text wrapper such as `<p></p>` (or
// `<p>&nbsp;</p>`) trims to a non-empty string but carries no text a reader would see. Built on
// the same tag-stripping pass `htmlToPlainText` uses so the two agree and this runs identically in
// the browser and in Node — a `DOMParser`-based check only works in the browser, and this same
// emptiness rule is needed server-side too (`CreateOutboundSupportTicket`).
export const isBlankHtml = (html?: string): boolean => isEmpty(htmlToPlainText(html))
